<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3yWK5W/tc-custom/9781467429283.jpg?1731055735096" alt="This image is the cover for the book Preaching Christ from the Old Testament"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Preaching Christ from the Old Testament
      </h1>
      <p class="bookDescription body article font2">
        <p>Arguing for the need both to preach Christ in every sermon and to preach regularly from the Old Testament, Sidney Greidanus develops a christocentric method that will help preachers do both simultaneously.<br/><br/> Greidanus challenges Old Testament scholars to broaden their focus and to understand the Old Testament not only in its own historical context but also in the context of the New Testament. Suggesting specific steps and providing concrete examples, this volume provides a practical guide for preaching Christ from the Old Testament.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sidney Greidanus
      </h2>
      
      <p class="authorDescription body article">&#160;<B>Sidney Greidanus</B>&#160;is professor emeritus of preaching at Calvin Theological Seminary and the author of several books, including&#160;<I>The Modern Preacher and the Ancient Text, Preaching Christ from the Old Testament, Preaching Christ from Genesis, Preaching Christ from Ecclesiastes, Preaching Christ from Daniel,</I>&#160;and&#160;<I>Preaching Christ from Psalms.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Puublishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5cb408c7